import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { BsBasket3 } from "react-icons/bs";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="header-left">
          <Link to="/shop" className="nav-link">
            Shop
          </Link>
          <Link to="/about" className="nav-link">
            About Us
          </Link>
          <Link to="/contact" className="nav-link">
            Contact Us
          </Link>
        </div>

        <div className="header-center">
          <Link to="/" className="logo-link" onClick={toTop}>
            <div className="logo-text">
              <span className="play">Petmorvanto</span>
              <div className="pet-container">
                <span className="brands">BRANDS</span>
              </div>
            </div>
          </Link>
        </div>

        <div className="header-right">
          <Link to="/cartpage" className="icon-link cart-icon">
            <BsBasket3 />
            {cartItems && cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
